import { Pipe, PipeTransform } from "@angular/core";
import { BadgeVariant } from "@sxm-content-creators/tools-ds";
import { Interactive, InteractiveDisplayState, getInteractiveDisplayState } from "../models/interactive.model";
export { InteractiveDisplayState } from "../models/interactive.model";

export const INTERACTIVE_DISPLAY_STATE_BADGE_LIBRARY: Record<InteractiveDisplayState, BadgeVariant> = {
    DRAFT: BadgeVariant.PILL_GRAY,
    PUBLISHED: BadgeVariant.PILL_GREEN,
    SCHEDULED: BadgeVariant.PILL_YELLOW,
    LIVE: BadgeVariant.PILL_GREEN,
    CLOSED: BadgeVariant.PILL_OUTLINE,
    PAUSED: BadgeVariant.PILL_OUTLINE,
    ARCHIVED: BadgeVariant.PILL_OUTLINE
};

@Pipe({ name: "interactiveDisplayState", standalone: true })
export class InteractiveDisplayStatePipe implements PipeTransform {
    transform(interactive: Interactive): InteractiveDisplayState {
        return getInteractiveDisplayState(interactive);
    }
}
